<template>
  <div id="app">
    <SemcogHeader>
      <span
       style="line-height: 2em; font-size: 1em;"
      >
        Demographic Emphasis Areas
      </span>
    </SemcogHeader>
    <Loader v-if="downloadingData > 0"/>
    <MainMap
      v-bind:geotype="geotype"
      v-bind:allGeojsonByType="allGeojsonByType"
      v-bind:scoreIndicator="scoreIndicator"
      v-bind:compositeScore="compositeScore"
      v-bind:nonScoreIndicators="nonScoreIndicators"
      v-bind:normalizationIndicator="normalizationIndicator"
      v-bind:indFromName="indFromName"
      v-bind:getIndMoeName="getIndMoeName"
      v-bind:groupNames="groupNames"
      v-bind:groups="groups"
      v-bind:selectedShortcut="selectedShortcut"
      v-bind:tiles="tiles"
      v-bind:namesFromGeotype="namesFromGeotype"
      v-bind:geotypesForMap="geotypesForMap"
      v-bind:selectedId="selectedId"
      v-bind:hoverId="printing ? null: hoverId"
      v-bind:filteredCounty="filteredCounty"
      v-bind:inInerMode="inInerMode"
      v-bind:scoreColorLookup="scoreColorLookup"
      v-on:set-sel-geom-id="setSelected($event)"
      v-on:set-hov-geom-id="hoverId = $event"
      v-on:composite-color="selectedCompositeColor = $event"
      v-on:set-norm="normalizationIndicator = $event"
      v-on:set-geo-type="setGeoType($event)"
      v-on:set-legend-color-data="setLegendData($event)"
    />
    <Profile
      v-bind:shortcuts="availableShortcuts"
      v-bind:groupNames="groupNames"
      v-bind:groups="groups"
      v-bind:groupDesc="groupDesc"
      v-bind:projectDefinitions="projectDefinitions"
      v-bind:project="project"
      v-bind:tiles="tiles"
      v-bind:nonScoreIndicators="nonScoreIndicators"
      v-bind:getIndName="getIndName"
      v-bind:aboutPageContent="aboutPageContent"
      v-bind:equityTooltips="equityTooltips"
      v-bind:getIndYear="getIndYear"
      v-bind:getIndMoeName="getIndMoeName"
      v-bind:incomeChartIndicators="incomeChartIndicators"
      v-bind:incomeChartCutoffs="incomeChartCutoffs"
      v-bind:ageDataMaleChartIndicators="ageDataMaleChartIndicators"
      v-bind:ageDataFemaleChartIndicators="ageDataFemaleChartIndicators"
      v-bind:allGeogData="filteredGeogData"
      v-bind:geotypesForMap="geotypesForMap"
      v-bind:countyData="countyData"
      v-bind:regionData="regionData"
      v-bind:selectedId="selectedId"
      v-bind:selectedCompositeColor="selectedCompositeColor"
      v-bind:filteredCounty="filteredCounty"
      v-bind:selectedName="selectedName"
      v-bind:namesForSelectedType="namesForSelectedType"
      v-bind:namesForCountyFilter="namesForCountyFilter"
      v-bind:hoverId="printing ? null: hoverId"
      v-bind:geotype="geotype"
      v-bind:namesFromGeotype="namesFromGeotype"
      v-bind:selectedShortcut="selectedShortcut"
      v-bind:colorLegendData="printing ? null: colorLegendData"
      v-bind:inInerMode="inInerMode"
      v-bind:printing="printing"
      v-bind:scoreColorLookup="scoreColorLookup"
      v-on:set-sel-geom-id="setSelected($event)"
      v-on:set-hov-geom-id="hoverId = $event"
      v-on:tiles="setTiles($event)"
      v-on:project="setTilesFromProject($event)"
      v-on:composite-score="(compositeScore = $event)"
      v-on:set-geo-type="setGeoType($event)"
      v-on:set-filtered-county="setFilteredCounty($event)"
    />
  </div>
</template>

<script>
import debounce from 'lodash.debounce'
import {diff} from 'deep-diff';
import * as turf from 'turf'
import {featureCollection} from 'turf'

import Profile from './components/Profile.vue'
import MainMap from './components/MainMap.vue'
import SemcogHeader from './components/SemcogHeader.vue'
import Loader from './components/map/Loader'
// eslint-disable-next-line
const names_csv = require('./names.csv')
// eslint-disable-next-line
const shortcuts_csv = require('./shortcuts.csv')

export default {
  name: 'app',
  components: { Loader, MainMap, Profile, SemcogHeader },
  data: function () {
    let shortcuts = Object.freeze(shortcuts_csv);
    let numerator = 'blacknonhisp_24'
    if (this.$route.query.tiles) {
      numerator = this.$route.query.tiles.split(',')[0]
    }
    let shortcut = shortcuts.find(s => s.numerator === numerator) || {
      numerator: 'blacknonhisp_24',
      denominator: 'totalpop_24',
    };
    let tiles = ['popage65andup_24', 'popage0_17_24', 'popminority_24','householdsinpoverty_24','hh_limitedenglish_24', 'hh_transitdependent_24', 'femalenospousehh_24', 'popdisability_24']
    if (this.$route.query.tiles){
      tiles = this.$route.query.tiles.split(',')
      tiles = tiles.filter(function (t) {
        return !t.includes('hhmedinc') //median income used to be a score tile, remove if you see it in the url
      })
      tiles = tiles.map((t) => {
        if (t.includes('_')) {
          let ind_parts = t.split('_')
          let year = ind_parts[ind_parts.length - 1]
          let non_year_parts = ind_parts.slice(0, -1)
          if (year === '19' || year === '20'|| year === '21' || year === '22' || year === '23') {
            non_year_parts.push('24')
            return non_year_parts.join('_')
          } else {
            return t
          }
        }
        return t
      })
    }
    if (shortcut.url) { // the url has a shortcut that we interpreted correctly
      // eslint-disable-next-line no-undef
      ga('send', 'event', 'url-selectedShortcut', shortcut.url, 'Demographic Emphasis Areas')
      // eslint-disable-next-line no-undef
      gtag('event', "url-selectedShortcut", {'change': shortcut.url, 'map_name': 'Demographic Emphasis Areas'});
    }
    let filteredCounty = parseInt(this.$route.query.filtered) || null;
    if (filteredCounty) {
      // eslint-disable-next-line no-undef
      ga('send', 'event', 'url-filteredCounty', filteredCounty, 'Demographic Emphasis Areas')
      // eslint-disable-next-line no-undef
      gtag('event', "url-filteredCounty", {'change': filteredCounty, 'map_name': 'Demographic Emphasis Areas'});
    }
    let geotype = 'CensusTract'
    if (this.$route.query.community && this.$route.query.community.length <= 4) {
      geotype = 'mcd'
    } else if (this.$route.query.community && this.$route.query.community.length >= 4) {
      geotype = 'CensusTract'
    }
    let selectedId = parseInt(this.$route.query.community) || null;
    if (selectedId) {
      // eslint-disable-next-line no-undef
      ga('send', 'event', 'url-selectedId', selectedId, 'Demographic Emphasis Areas')
      // eslint-disable-next-line no-undef
      gtag('event', "url-selectedId", {'change': selectedId, 'map_name': 'Demographic Emphasis Areas'});
    }
    let project = this.$route.query.project;
    if (project) {
      project = this.$route.query.project
    } else {
      project = 'Transportation Analysis'
    }
    if (project === 'Transportation Equity') {
      project = 'Transportation Analysis'
    }

    return {
      downloadingData: 0,
      printing: false,
      inInerMode: true,
      selectedId,
      selectedCompositeColor: 'grey',
      hoverId: null,
      filteredCounty,
      project: project,
      geotype: geotype,
      geotypes: Object.freeze(['region', 'mcd', 'county', 'CensusTract']), // , 'BlockGroup'
      geotypesForMap: Object.freeze(['mcd', 'CensusTract']),
      namesFromGeotype: Object.freeze({
        'county': {
          name: 'Counties',
          singularName: 'County',
        },
        'mcd': {
          name: 'Communities',
          singularName: 'Community',
        },
        'CensusTract': {
          name: 'Census Tracts',
          singularName: 'Census Tract',
        },
      }),
      mappedIndicator: shortcut.numerator,
      normalizationIndicator: shortcut.denominator,
      compositeScore: 0,
      nonScoreIndicators: ['hhmedinc_24'],
      equityTooltips: {
        'blacknonhisp_24': {
          tooltip: `tooltip`,
          content: `Includes people who reported Black and no other race group and did
              not report being of Hispanic origin.`,
        },
                'asiannonhisp_24': {
          tooltip: `tooltip`,
          content: `Includes people having origins in any of the following - Far East,
              Southeast Asia, or the Indian subcontinent and did not report being of Hispanic origin.`,
        },
                'hispanic_24': {
          tooltip: `tooltip`,
          content: `Refers to a person of Cuban, Mexican, Puerto Rican, South or Central American,
              or other Spanish culture or origin regardless of race.`,
        },
                'popother_24': {
          tooltip: `tooltip`,
          content: `Includes all other races not included in the “Non-Hispanic
              White,” “Non-Hispanic Black or African American,” and “Non-Hispanic Asian”. People belonging to any
              Hispanic ethnicity or origin are also not included in this category.`,
        },
                'popminority_24': {
          tooltip: `tooltip`,
          content: `Includes people that are of “Black or African American,” “American Indian or
              Alaska Native,” “Asian,” and “Native Hawaiian or Other Pacific Islander” race categories. Persons
              reporting as multiracial, mixed, interracial, or a Hispanic, Latino, or Spanish group are also included in
              this category. Any person who is not a “Non-Hispanic White” is considered as a Minority.`,
        },
                'popage0_17_24': {
          tooltip: `tooltip`,
          content: `Population aged 0 to 17 years.`,
        },
                'popage5_17_24': {
          tooltip: `tooltip`,
          content: `Population aged 5 to 17 years.`,
        },
                'popage16_19_noschoolorwork_24': {
          tooltip: `tooltip`,
          content: `Population aged 16 to 19 years who are not enrolled in school, not
              employed and/or not in the labor force.`,
        },
                'popage65andup_24': {
          tooltip: `tooltip`,
          content: `Population aged 65 years or older.`,
        },
                'popforeignborn_24': {
          tooltip: `tooltip`,
          content: `Foreign born refers to people who are not U.S. citizens at birth. This
              includes naturalized U.S. citizens, lawful permanent residents (immigrants), temporary migrants (such as
              foreign students), humanitarian migrants (such as refugees and asylees), and persons illegally present in
              the United States.`,
        },
                'popinpoverty_24': {
          tooltip: `tooltip`,
          content: `Census Bureau’s poverty status is determined for all persons except
              institutionalized persons, persons in military group quarters and in college dormitories, and unrelated
              individuals under 15 years old.`,
        },
                'popdisability_24': {
          tooltip: `tooltip`,
          content: `Disability includes persons with any of the following disabilities –
              hearing, vision, cognitive, ambulatory, self-care, or independent living difficulty.`,
        },
                'femalenospousehh_24': {
          tooltip: `tooltip`,
          content: `A female maintaining a household with no husband of the
              householder present.`,
        },
                'householdsinpoverty_24': {
          tooltip: `tooltip`,
          content: `If a household’s total income is less than the federal poverty
              threshold, then that household and every individual in it is considered in poverty.`,
        },
                'hh_transitdependent_24': {
          tooltip: `tooltip`,
          content: `Households with no vehicle or number of vehicles less than
              the number of workers in the household.`,
        },
                'hh_limitedenglish_24': {
          tooltip: `tooltip`,
          content: `A "limited English speaking household" is one in which no
              member 14 years old and over (1) speaks only English or (2) speaks a non-English language and speaks
              English "very well." In other words, all members 14 years old and over have at least some difficulty with
              English.`,
        },
                'hh_housingcostburden_24': {
          tooltip: `tooltip`,
          content: `HUD defines cost-burdened households as those “who pay more than 30
              percent of their income for housing” and “may have difficulty affording necessities such as food,
              clothing, transportation, and medical care.”`,
        },
                'hh_nocar_24': {
          tooltip: `tooltip`,
          content: `Households with no vehicles. These households are also transit
              dependent.`,
        },
                'hhmedinc_24': {
          tooltip: `tooltip`,
          content: `Median Household Income`,
        },
                'unemploymentrate_24': {
          tooltip: `tooltip`,
          content: `Unemployment Rate`,
        },
      },
      aboutPageContent: {
        'map': {
          tooltip: `About this map`,
          content: `<h1>Demographic Emphasis Areas</h1>
                    <p> About this map...</p>`,
        },
      },
      scoreColorLookup: {
        0: {//#fffad7,#fce7a8,#f5c25e,#78c679,#006837
          color: "#fffad7",
          name: "Well Below Average",
        },
        1: {
          color: "#fce7a8",
          name: "Below Average",
        },
        2: {
          color: "#f5c25e",
          name: "Average",
        },
        3: {
          color: "#78c679",
          name: "Above Average",
        },
        4: {
          color: "#006837",
          name: "Well Above Average",
        },
      },
      projectDefinitions: {
        'None': {
          tiles: ['blacknonhisp_24'],
        },
        'Environmental Impact Analysis': {
          tiles: ['popminority_24', 'popage65andup_24', 'householdsinpoverty_24', 'hh_nocar_24'],
        },
        'Bike and Ped Plan': {
          tiles: ['popage65andup_24', 'popage0_17_24', 'popminority_24','popinpoverty_24', 'hh_transitdependent_24'],
        },
        'Transportation Analysis': {
          tiles: ['popage65andup_24', 'popage0_17_24', 'popminority_24','householdsinpoverty_24','hh_limitedenglish_24', 'hh_transitdependent_24', 'femalenospousehh_24', 'popdisability_24'],
        },
      },
      groupDesc: Object.freeze({
        // TODO: update/remove unneeded group descriptions
        'Population': {
          desc:
            'Southeast Michigan is home to a diverse population of over <strong>4.7 million</strong> people that make up our cities, villages, and townships.',
          descExtra: 'All people, male and female, child and adult, living in a given geographic area.  Source: American Community Survey 2020-2024 5-Year Estimates.',
          iconName: 'user-alt',
        },
        'Other': {
          desc:
            '',
          descExtra: '',
          iconName: 'folder',
        },
        'Demographic': {
          desc:
            'Click on a dataset below to map it by index score. Index scores range from 0 to 4 and can be combined to create a composite score.',
          descExtra: 'Source: American Community Survey 2020-2024 5-Year Estimates.',
          iconName: 'users',
        },
        'Reference': {
          desc:
            'Southeast Michigan is home to a diverse population of over <strong>4.7 million</strong> people that make up our cities, villages, and townships.',
          descExtra: 'All people, male and female, child and adult, living in a given geographic area.  Source: American Community Survey 2020-2024 5-Year Estimates.',
          iconName: 'user-alt',
        },
        'Internet': {
          longName: 'Internet/Computer Access',
          desc: 'Access to internet and computing devices is more critical than ever. Over <strong>80%</strong> of our region\'s housholds have access to these important resources.',
          descExtra: 'Source: American Community Survey 2020-2024 5-Year Estimates.',
          iconName: 'wifi',
        },
        'Housing': {
          desc:
            'Nearly <strong>2.1 million</strong> housing units provide residential choices in Southeast Michigan.',
          descExtra: 'Housing unit is an independent house, a townhome, an apartment, or a mobile home or trailer that is either occupied or vacant. Source: American Community Survey 2020-2024 5-Year Estimates.',
          iconName: 'home',
        },
        'Economics': {
          desc:
            'Economic activities support about <strong>2.8 million</strong> jobs in Southeast Michigan.',
          descExtra: 'Jobs and job densities are from 2015 SEMCOG estimates and represent total full-time and part-time employment including both wage and salary jobs, as well as self-employed jobs. Other economic indicators are based on American Community Survey 2020-2024 5-Year Estimates. Note regarding Day Time Population: The number of residents attending school outside Southeast Michigan is not available. Likewise, the number of students commuting into Southeast Michigan to attend school is also not known.',
          iconName: 'dollar-sign',
        },
      }),
      shortcuts,
      tiles: tiles,
      // TODO: remove income chart indicators
      incomeChartIndicators: Object.freeze([
        'ehhlessthan_10000_21',
        'ehh_10000to_14999_21',
        'ehh_15000to_19999_21',
        'ehh_21000to_24999_21',
        'ehh_25000to_29999_21',
        'ehh_30000to_34999_21',
        'ehh_35000to_39999_21',
        'ehh_40000to_44999_21',
        'ehh_45000to_49999_21',
        'ehh_50000to_59999_21',
        'ehh_60000to_74999_21',
        'ehh_75000to_99999_21',
        'ehh_100000to_124999_21',
        'ehh_125000to_149999_21',
        'ehh_150000to_199999_21',
        'ehh_210000ormore_21',
      ]),
      incomeChartCutoffs: Object.freeze([
        0,
        10000,
        15000,
        20000,
        25000,
        30000,
        35000,
        40000,
        45000,
        50000,
        60000,
        75000,
        100000,
        125000,
        150000,
        200000,
        250000,
      ]),
      ageDataMaleChartIndicators: Object.freeze([
        // TODO: remove these
        'popmale0_5_21',
        'popmale5_9_21',
        'popmale10_14_21',
        'popmale15_19_21',
        'popmale20_24_21',
        'popmale25_29_21',
        'popmale30_34_21',
        'popmale35_39_21',
        'popmale40_44_21',
        'popmale45_49_21',
        'popmale50_54_21',
        'popmale55_59_21',
        'popmale60_64_21',
        'popmale65_69_21',
        'popmale70_74_21',
        'popmale75_79_21',
        'popmale80_84_21',
        'popmale85andup_21',
      ]),
      ageDataFemaleChartIndicators: Object.freeze([
        // TODO: remove these
        'popfemale0_5_21',
        'popfemale5_9_21',
        'popfemale10_14_21',
        'popfemale15_19_21',
        'popfemale20_24_21',
        'popfemale25_29_21',
        'popfemale30_34_21',
        'popfemale35_39_21',
        'popfemale40_44_21',
        'popfemale45_49_21',
        'popfemale50_54_21',
        'popfemale55_59_21',
        'popfemale60_64_21',
        'popfemale65_69_21',
        'popfemale70_74_21',
        'popfemale75_79_21',
        'popfemale80_84_21',
        'popfemale85andup_21',
      ]),
      colorLegendData: null,
      allGeojsonByType: Object.freeze(new Map()),
    }
  },
  mounted: function () {
    const mql = window.matchMedia('print')
    const cb = ({ matches }) => {
      this.printing = matches
    }
    // IOS dose not  work with addEventListener
    mql.addListener(cb)
    cb(mql)
  },
  computed: {
    geojsonFile: function () {
      return './geojson/boundaries.geojson'
    },
    nameFromId: function () {
      let nameFromId = new Map()
      this.geotypes.forEach(type => {
        nameFromId.set(type, new Map((this.allGeogData.get(type) || []).map(val => [val.geoid, [(val.name || '').trim(), val.county]])))
      })
      return nameFromId
    },
    namesForSelectedType: function () {
      if (!this.nameFromId.get(this.geotype)) {
        return new Map()
      }
      if (!this.filteredCounty) {
        return this.nameFromId.get(this.geotype)
      }
      return new Map(Array.from(this.nameFromId.get(this.geotype)).filter(g => g[1][1] === this.filteredCounty))
    },
    namesForCountyFilter: function () {
      return this.nameFromId.get('county') || new Map()
    },
    filteredGeogData: function () {
      if (!this.allGeogData.get(this.geotype)) {
        return []
      }
      if (!this.filteredCounty) {
        return this.allGeogData.get(this.geotype)
      }
      return this.allGeogData.get(this.geotype).filter(g => (g.county === this.filteredCounty) || (g.county2 === this.filteredCounty))
    },
    selectedName: function () {
      let out = this.namesForSelectedType.get(this.selectedId)
      if (!out) {
        return
      }
      return out[0]
    },
    selectedCounty: function () {
      let out = this.namesForSelectedType.get(this.hoverId || this.selectedId)
      if (!out) {
        return this.filteredCounty
      }
      return out[1]
    },
    countyData: function () {
      let out = this.allGeogData.get('county')
      if (!out) {
        return {}
      }
      return out.find(row => row.geoid === this.selectedCounty) || {}
    },
    regionData: function () {
      let out = this.allGeogData.get('region')
      if (!out) {
        return {}
      }
      return out.find(r => r.geoid === 8999)
    },
    indFromName: function () {
      let out = {}
      let columnsInGeojson = this.columnsByGeoType.get(this.geotype)
      if (!columnsInGeojson || !columnsInGeojson.values) {
        return out
      }
      for (let ind of columnsInGeojson.values()) {
        if (ind.startsWith('m_')) {
          continue // all moe's start with 'm_'
        }
        let name = this.getIndName(ind)
        if (!out[name]) {
          out[name] = {}
        }
        out[name][this.getIndYear(ind)] = ind
      }
      return out
    },
    scoreIndicator: function () {
      let score = undefined;
      if (this.nonScoreIndicators.includes(this.mappedIndicator)) {
        score = this.mappedIndicator
      } else {
        score = 'score_' + (this.mappedIndicator || 'blacknonhisp_24')
      }
      return score
    },
    availableShortcuts () {
      let columnsInGeojson = this.columnsByGeoType.get(this.geotype)
      if (!columnsInGeojson || !columnsInGeojson.has) {
        return []
      }
      return this.shortcuts.filter(
        s => (columnsInGeojson.has(s.numerator)) && (columnsInGeojson.has(s.denominator))
      )
    },
    selectedShortcut: function () {
      return this.availableShortcuts.find(s => s.numerator === this.mappedIndicator)
    },
    groupNames: function () {
      let groups = new Set()
      for (let short of this.availableShortcuts) {
        groups.add(short.group)
      }
      return Array.from(groups)
    },
    groups: function () {
      let groups = {}
      for (let short of this.availableShortcuts) {
        if (!groups[short.group]) {
          groups[short.group] = []
        }
        groups[short.group].push(short)
      }
      return groups
    },
    namesFromCore: function () {
      let out = {}
      names_csv.forEach(f => {
        out[f.core] = f.name
      })
      return out
    },
    columnsByGeoType: function () {
      let columnsByGeoType = new Map()
      this.geotypes.forEach(type => {
        let g = new Set();
        (this.allGeogData.get(type) || []).forEach(f =>
          Object.keys(f).forEach(c => {
              if (type === 'mcd' && (c === 'raise' || c === 'dac_cvr')) {
                return
              } else if (type !== 'mcd' && (c === 'disadvantagedcommunity' || c === 'pct_hh_below_alice_threshold_19' || c === 'pct_alice_households_19')) {
                return
              } else if (f[c] && !isNaN(f[c])) {
                g.add(c)
              }
            },
          ),
        )
        columnsByGeoType.set(type, g)
      })
      return columnsByGeoType
    },
    allGeogData: function () {
      let allGeogData = new Map()
      this.geotypes.forEach(type => {
        let json = this.allGeojsonByType.get(type)
        if (json && json.features) {
          allGeogData.set(type, json.features.map(f => f.properties))
        }
      })
      return allGeogData
    },
    urlData: function () {
      if (this.downloadingData) {
        // none of our computed are right without data so just leave the url the same
        return this.$route.query
      }
      let query = {};
      if (this.selectedId && this.selectedId !== 8999) {
        query.community = this.selectedId.toString()
      }
      if (this.filteredCounty) {
        query.filtered = this.filteredCounty.toString()
      }
      if (this.tiles) {
        query.tiles = this.tiles.toString()
      }
      if (this.project && this.inInerMode && this.project !== 'None') {
        query.project = this.project.toString()
      }
      return query;
    },
  },
  methods: {
    setTilesFromProject: function (project) {
      if (project !== 'None') {
        this.setTiles(this.projectDefinitions[project].tiles)
      }
      this.project = project
    },
    getIndName: function (ind) {
      let core = ind
      if (ind.match(/_\d\d$/gi)) {
        core = ind.slice(0, -3)
      }
      return this.namesFromCore['e'+core] || core
    },
    getIndMoeName: function (ind) {
      let columnsInGeojson = this.columnsByGeoType.get(this.geotype)
      let moe = undefined
      if (!columnsInGeojson || !columnsInGeojson.has) {
        return moe
      }
      if (columnsInGeojson.has('m_' + ind)) {
        moe = 'm_' + ind
      }
      return moe
    },
    getIndYear: function (ind) {
      let year = ind.match(/_\d\d$/gi)
      if (year) {
        year = 2000 + parseInt(year[0].slice(1), 10)
      }
      return year || 'N/A'
    },
    setFilteredCounty (id) {
      this.filteredCounty = +id || id
      if (!this.namesForSelectedType.get(this.selectedId)) {
        this.selectedId = null
      }
    },
    setSelected (id) {
      this.selectedId = id
      if (!id || id === 8999) {
        this.setFilteredCounty(null)
      }
    },
    setMap(id) {
      if (this.tiles.length === 1) {
        if (this.nonScoreIndicators.includes(id[0])) {
          this.mappedIndicator = id[0]
          this.normalizationIndicator = id[1]
        }
      }
    },
    setTiles (tiles) {
      if (tiles) {
        this.mappedIndicator = tiles[0]
      }
      if (tiles.length === 1) {
        this.normalizationIndicator = 'constant'
        this.tiles = [tiles[0]]
      } else {
        this.tiles = tiles
      }
    },
    setLegendData: debounce(function (id) {
      this.colorLegendData = Object.freeze(id)
    }, 200),
    setGeoType: function (id) {
      this.geotype = id
      this.hoverId = null

      let columnsInGeojson = this.columnsByGeoType.get(id)

      this.tiles = this.tiles.filter(t => columnsInGeojson.has(t))
      if (this.tiles.length === 0) {
        this.tiles = ['blacknonhisp_24']
        this.setTiles(this.tiles)
      }

      if (!columnsInGeojson.has(this.mappedIndicator) || !columnsInGeojson.has(this.normalizationIndicator)) {
        this.mappedIndicator = 'totalpop_24'
        this.normalizationIndicator = 'acres'
      }

      if (id === 'county') {
        this.filteredCounty = null
      }
    },
  },
  watch: {
    geojsonFile: {
      immediate: true,
      handler:
        function () {
          this.downloadingData += 1
          fetch(this.geojsonFile).then(r => r.json()).then(data => {
            if (data.description) {
              let names = data.description.split(',')
              data.features.forEach(f => {
                let out = {}
                Object.keys(f.properties).forEach(p => {
                  out[names[parseInt(p, 16)]] = f.properties[p]
                })
                f.properties = out
              })
            }
            let offset = data.features.find(f => f.properties.geoid === 8999)
            if (offset) {
              offset = offset.geometry && offset.geometry.coordinates
              if (offset.length && offset.length === 2) {
                let offset_x = offset[0]
                let offset_y = offset[1]
                turf.coordEach(data, pointCoords => {
                  pointCoords[0] -= offset_x
                  pointCoords[1] -= offset_y
                })
              }
            }
            const geotypes = new Set(data.features.map(row => row.properties.geotype))
            let allGeojsonByType = new Map()
            geotypes.forEach(type => {
              allGeojsonByType.set(type, featureCollection(data.features.filter(row => row.properties.geotype === type)))
            })
            this.allGeojsonByType = Object.freeze(allGeojsonByType)
            this.$nextTick(() => {
              this.downloadingData -= 1
            })
          });
        },
    },
    urlData: function (newUrl, oldUrl) {
      if (diff(oldUrl, newUrl)) {
         this.$router.replace({ query: this.urlData })
      }
    },
    tiles: function (n, o) {
      if (n && diff(n, o)) {
        // eslint-disable-next-line no-undef
        ga('send', 'event', 'change-tiles', n, 'Demographic Emphasis Areas')
        // eslint-disable-next-line no-undef
        gtag('event', "change-tiles", {'change': n, 'map_name': 'Demographic Emphasis Areas'})
      }
    },
    geotype: function (n, o) {
      if (n && diff(n, o)) {
        // eslint-disable-next-line no-undef
        ga('send', 'event', 'change-geotype', n, 'Demographic Emphasis Areas')
        // eslint-disable-next-line no-undef
        gtag('event', "change-geotype", {'change': n, 'map_name': 'Demographic Emphasis Areas'})
      }
    },
    project: function (n, o) {
      if (n && diff(n, o)) {
        // eslint-disable-next-line no-undef
        ga('send', 'event', 'change-project', n, 'Demographic Emphasis Areas')
        // eslint-disable-next-line no-undef
        gtag('event', "change-project", {'change': n, 'map_name': 'Demographic Emphasis Areas'})
      }
    },
    filteredCounty: function (n, o) {
      if (n && diff(n, o)) {
        // eslint-disable-next-line no-undef
        ga('send', 'event', 'change-filteredCounty', n, 'Demographic Emphasis Areas')
        // eslint-disable-next-line no-undef
        gtag('event', "change-filteredCounty", {'change': n, 'map_name': 'Demographic Emphasis Areas'})
      }
    },
    selectedShortcut: function (n, o) {
      if (n && n.url && o &&  diff(o, n)) {
        // eslint-disable-next-line no-undef
        ga('send', 'event', 'change-selectedShortcut', n.url, 'Demographic Emphasis Areas')
        // eslint-disable-next-line no-undef
        gtag('event', "change-selectedShortcut", {'change': n.url, 'map_name': 'Demographic Emphasis Areas'})
      }
    },
    selectedId: function (n, o) {
      if (n && diff(n, o) && n !== 8999) {
        // eslint-disable-next-line no-undef
        ga('send', 'event', 'change-selectedId', n, 'Demographic Emphasis Areas')
        // eslint-disable-next-line no-undef
        gtag('event', "change-selectedId", {'change': n, 'map_name': 'Demographic Emphasis Areas'})
      }
    },
    inInerMode: function () {
      if (!this.inInerMode) {
        this.project = 'None'
      }
    },
  },
}

</script>

<style scoped>
  #app {
    width: 100%;
    height: 100vh;
    display: grid;
    grid-template-columns: 48% auto;
    grid-template-rows: max-content auto;
    font-family: Arial, Helvetica, sans-serif;
  }

  @media (max-width: 1500px), print {
    #app {
      grid-template-columns: 35% auto;
    }
  }

  @media (max-width: 576px), print {
    #app {
      height: initial;
      grid-template-columns: auto;
      grid-template-rows: max-content auto auto;
    }
  }
</style>
